import { Controller } from "stimulus";
import getUrlParamString from "../../functions/getUrlParamString.js";
import dispatchCustomEvent from "../../functions/dispatchCustomEvent.js";

export default class extends Controller {
  static get values() {
    return { store: Boolean, page: String, limit: String, totalPages: String };
  }

  connect() {
    if (this.saveToStore) this._registerWithStore();
  }

  onPaginate(event) {
    event.preventDefault();
    this._handleStateChange(event.currentTarget.href);
  }

  onLimitChange(event) {
    this._handleStateChange(event.target.value);
  }

  _handleStateChange(urlString) {
    if (this.saveToStore) {
      const url = new URL(urlString, window.location.origin);

      this._syncWithStore({ page: url.searchParams.get("page"), limit: url.searchParams.get("limit") });
    }

    this._dispatchReload(urlString);
  }

  _dispatchReload(urlString) {
    dispatchCustomEvent(document, this.eventName, true, true, { queryString: getUrlParamString(urlString) });
  }

  // Store methods

  _registerWithStore() {
    this.dispatch("register", {
      detail: { id: this.eventName, values: { page: this.pageValue, limit: this.limitValue } },
      prefix: false,
    });
  }

  _syncWithStore(values) {
    this.dispatch("sync", {
      detail: { id: this.eventName, values },
      prefix: false
    });
  }

  updateFromStore({ detail: { id, values } }) {
    if (id !== this.eventName || !values) return;

    let { page, limit } = values;

    if (parseInt(page) > parseInt(this.totalPagesValue) && limit === this.limitValue) {
      page = "1";
      this._syncWithStore({ limit, page });
    }

    if (page === this.pageValue && limit === this.limitValue) return;

    const url = new URL(this.currentUrl, window.location.origin);
    this._dispatchReload(this._buildUrl(url, page, limit));
  }

  _buildUrl(urlObj, page, limit) {
    if (page) urlObj.searchParams.set("page", page);
    if (limit) urlObj.searchParams.set("limit", limit);

    return `${urlObj.pathname}${urlObj.search}`;
  }

  get eventName() {
    return this.element.dataset.eventName;
  }

  get currentUrl() {
    return document.getElementById(this.eventName.replace("reload-", "")).dataset.url;
  }

  get saveToStore() {
    return this.hasStoreValue && this.storeValue;
  }
}
